var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHideShow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 18,
  viewBox: "0 0 32 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M31.2 8.4C24.9.8 18.8-.7 13.7.2 16.2 1 18 3.3 18 6c0 3.3-2.7 6-6 6S6 9.3 6 6c0-1 .3-2 .7-2.9C3.2 5.5 1 8.2 1 8.2c-2.2 2.3 0 4.3 0 4.3 13.2 15.6 28.6 2.1 30.4 0 1.6-1.9-.2-4.1-.2-4.1z"
})));
export default SvgIconHideShow;